import MenuWrapper from '../Compartido/menu.jsx';
import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Header({ lang, ruta, config, meta_titulo, meta_descripcion, meta_keywords }) {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    var imagen = "/images/apartur/denuncia-es.png";

    if (lang == 'ca')
        imagen = "/images/apartur/denuncia-ca.png";


    return (
        <div id="Header_wrapper" style={{ backgroundImage: "url('" + imagen + "')", backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: "contain", backgroundColor: "#FFF" }}>
            <header id="Header">
                <MenuWrapper
                    preidioma={preidioma}
                    lang={lang}
                    config={config}
                    ruta={ruta}
                    meta_titulo={t("APARTUR DENUNCIA")}
                    meta_descripcion={meta_descripcion}
                    meta_keywords={meta_keywords}
                />
            </header>
            <div id="Subheader">
                <div className="container">
                    <div className="column one">
                        <h1 className="title text-uppercase"></h1>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Header;
